<template>
  <!-- 编辑商品上架信息 -->
  <div>
    <div class="pageTitleWrap">
      <vs-breadcrumb :items="breadcrumb" class="marLeft12"></vs-breadcrumb>
    </div>
    <!-- 合并上架 -->
    <div class="main-wrap">
      <form class="frombox" id="edit-good-form">
        <div class="form-item">
          <div class="label">总上架数</div>
          <vs-input disabled="true" name="allSellNum" v-model="allSellNum" />
        </div>
        <div class="form-item">
          <div class="label">上架模式</div>
          <v-select v-model="sellType" :options="shelfModeOptions" :reduce="opt => opt.id"
                    placeholder="" :disabled="!editFlag">
            <div slot="no-options">暂无选项</div>
          </v-select>
        </div>

        <div class="form-item form__clear" v-if="sellType == 1">
          <div class="label">上架逻辑</div>
          <v-select v-model="shelfLogic" :options="shelfLogicOptions" :reduce="opt => opt.id"
                    placeholder="" :disabled="!editFlag">
            <div slot="no-options">暂无选项</div>
          </v-select>
        </div>
        <div class="form-item" v-if="mergeFlag">
          <div class="label">上架数量(个)</div>
          <vs-input-number @mousewheel.prevent v-model="shelfNum" name="shelfNum" :disabled="!editFlag" min="1"/>
        </div>
        <!-- <div class="form-item">
          <div class="label">上架类型</div>
          <v-select v-model="customerSelType" :options="customerSelTypeList" :reduce="opt => opt.label"
                  placeholder="" :disabled="!editFlag">
            <div slot="no-options">暂无选项</div>
          </v-select>
        </div>         -->
        <!-- 类型 todo -->
        <div class="form-item">
          <div class="label">上架类型</div>
          <v-select v-model="customerSelType" :options="customerSelTypeList" :reduce="opt => opt.label"
                    placeholder="" :disabled="!editFlag" multiple>
            <div slot="no-options">暂无选项</div>
          </v-select>
        </div>
        <div class="form-item"  v-if="customerSelType != ''">
          <div class="label">上架范围</div>
          <template>
            <v-select v-model="customerType" :options="customerTypeOptions" :reduce="opt => opt.label"
                      placeholder="" :disabled="!editFlag" multiple>
              <div slot="no-options">暂无选项</div>
            </v-select>
          </template>
        </div>
      </form>
      <div class="firstTitle">上架列表</div>
      <div class="flex">
        <vs-button
                type="border"
                size="small"
                @click.prevent="formatTableData(true)"
                class="common-btn">批量删除</vs-button>
        <vs-button
                v-show="!mergeFlag"
                type="border"
                size="small"
                @click.prevent="formatTableData(false)"
                class="common-btn marLeft16"
        >批量清零</vs-button>
        <vs-button
                v-show="!mergeFlag"
                type="border"
                size="small"
                @click.prevent="clearTableData()"
                class="common-btn marLeft16"
        >批量清空剩余上架数</vs-button>
        <gc-cmp-vs-input v-model="filterText" class="filterInput marLeft16"
                         placeholder="客户名称" />
        <vs-button type="filled" size="small" @click.prevent="searchData" class="marLeft16">查询</vs-button>
        <div class="flex alignCenter search-add-wrap" style="z-index:999">
          <search-input
                  ref="bookmarkAutoSuggest"
                  :autoFocus="true"
                  :data="delCustomerOptions"
                  :searchLimit="5"
                  placeholder="请输入要恢复的客户名称"
                  inputClassses="w-full"
                  show-action
                  show-pinned
                  hideGroupTitle
                  background-overlay
                  showName="customerName"
                  @input="searchInputSuggest"
                  @selected="addSelectCustomer" />
          <vs-button color="primary" type="flat" class="table-inner-btn" @click="addCustomer">添加</vs-button>
        </div>
      </div>
    </div>
    <vs-table multiple :data="tableData" v-model="selectedRowData"
              ref="table" noDataText="暂无数据">
      <template slot="thead">
        <vs-th style="width:60px">序号</vs-th>
        <vs-th style="width:250px">商品名称</vs-th>
        <vs-th>客户/门店类型</vs-th>
        <vs-th style="width:250px">客户/门店名称</vs-th>
        <template v-if="!mergeFlag">
          <vs-th>剩余上架数</vs-th>
          <vs-th class="center-num">上架数量</vs-th>
        </template>
        <vs-th>操作</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>{{ indextr + 1 }}</vs-td>
          <vs-td>{{ tr['skuName']}}</vs-td>
          <vs-td>{{ tr['customerType'] }}</vs-td>
          <vs-td>{{ tr['customerName']}}</vs-td>
          <template v-if="!mergeFlag">
            <!-- 剩余上架数 -->
            <vs-td>{{ tr['oldNum']}}</vs-td>
            <!-- 上架数量 -->
            <vs-td v-if="editFlag">
              <vs-input-number @mousewheel.prevent v-model="tr.shelfNum" max="99999999"  @input="shelfNumChange(tr,indextr,$event)" min="0" />
            </vs-td>
            <vs-td v-else>{{ tr['shelfNum'] }}</vs-td>
          </template>

          <vs-td>
            <template v-if="editFlag">
              <div class="shelfLogic" v-if="sellType == 2">
                <div :class="tr['shelfLogic'] == 1?'item active':'item'" @click.stop="shelfLogicAdd(tr)" >增量</div>
                <div :class="tr['shelfLogic'] == 0?'item active':'item'" @click.stop="shelfLogicReduce(tr)" >减量</div>
              </div>
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 stroke-current" class="text-danger"
                            @click.stop="deleteCustomer(tr)" />
            </template>
            <div v-else>-</div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <!-- <div v-if="tableData.length == 0" class="vs-table--not-data">
      <img src="@/assets/images/commodity-sys/no-data.png" />
      <div class="nodata-text">暂无数据</div>
    </div> -->
    <!-- 本地分页 -->
    <!-- <gc-vs-pagination :total="localPager.total" v-model="localPager.page" :max="7"
                    :goto="true" class="marTop16"></gc-vs-pagination> -->

    <gc-vs-pagination
            :pager="localPager"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
    ></gc-vs-pagination>
    <div v-if="editFlag" class="bot-btn-wrap">
      <vs-button type="filled" @click.prevent="submit()">确定上架</vs-button>
      <vs-button type='border' @click.prevent="cancelAffirm()" class="marLeft8">取消</vs-button>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
  import commodityTable from "@/modules/commodity-sys/components/commodity-table";
  import GcCmpVsInput from "@/group-cloud/components/vsInput";
  import {Mod_Clients} from "@/modules/server-api/Clients";
  import {Mod_Stores} from "@/modules/server-api/Stores";
  import {
    OnShelvesApi,
    Shelf_Mode_Types,//上架模式
    Shelf_Mode_Types_Opts,
    Logic_Mode_Types,//上架逻辑
    Logic_Mode_Opts,
    Customer_Types_Goods_Opts, //上架类型（客户类型）：门店，省代，SKA,CVS
    Customer_Store_Types_Opts,
    Customer_once_Types_Goods_Opts,Customer_inner_Types_Goods_Opts
  } from "@/modules/server-api/commodity-sys/on-shelves";
  import { $busErrorCode } from "@/modules/commodity-sys/common.js";
  import VsTable from "@/modules/order/vsTable/vsTable"
  import VsTd from "@/modules/order/vsTable/vsTd"
  import VsTh from "@/modules/order/vsTable/vsTh"
  import VsTr from "@/modules/order/vsTable/vsTr"
  import SearchInput from '@/modules/wms-manage/components/searchInput.vue';
  export default {
    data() {
      return {
        breadcrumb: [],  //菜单
        initFlag: true,//初始化的时候
        mergeFlag: false, //是否是合并上架
        sellType: '', //上架模式
        shelfModeTypes: Shelf_Mode_Types,//上架模式:1是合并上架；2是分开上架
        shelfModeOptions: Shelf_Mode_Types_Opts,
        shelfLogic: 1,//上架逻辑 ：0减量,1增量
        logic_type: Logic_Mode_Types,
        shelfLogicOptions: Logic_Mode_Opts,
        isTypesAll: false, //上架类型多选时为true
        customerSelType: "",//客户(门店还是分销商)
        customerSelTypeList: [],
        customerType: [], //上架类型(客户类型)
        customerTypeOptions: Customer_Types_Goods_Opts,//上架类型（客户类型）,
        editFlag: true,//是否可编辑：状态为1可编辑 0不可编辑
        // allSellNum: -1,//总上架数
        editAllSellNum: -1,//编辑时总上架数
        shelfNum: 0,//本次上架数
        filterText: '', //模糊搜索词
        allTableData: [], //前台搜索，故需存储结果
        tableData: [],
        selectedRowData:[],
        skuSellConfigId: '',
        currSkuCode: '',//当前编辑的商品
        currSkuName: '',
        userIdprefix: 'store', //用于区分门店还是分销商，回显用
        // searchDataCode: 0, //0是正常getlist，1是通过查询getlist
        localPager:{
          page: 1,
          size: 20,
          total: 0
        },
        deleteTableData: [], //已经删除的客户数据
        delCustomerOptions:[], //模糊搜索已经删除的客户数据
        delSelected: {}
      }
    },
    computed: {
      modalTitle() {
        return this.skuInfo.goodsName + '上架数编辑';
      },
      //上架总数量
      allSellNum: {
        set(){},
        get(){
          let tempNum = 0;
          if(this.mergeFlag){//合并上架
            if(this.shelfLogic === this.logic_type.ADD){//增量
              tempNum = Number(this.editAllSellNum) + Number(this.shelfNum);
            }else if(this.shelfLogic === this.logic_type.REDUCE){//减量
              tempNum = Number(this.editAllSellNum) - Number(this.shelfNum);
            }
          }else{
            if(this.allTableData.length){
              this.allTableData.map(item => {
                tempNum += item.deleteFlag ? 0 : Number(item.num);
              })
            }
          }
          // console.log('====计算总上架数====', tempNum);
          return tempNum;
        }
      }
    },
    mounted(){
      if(this.$doMainFunc() === '力当家'){
        this.customerSelTypeList = [
          {id:1, label:'门店'},
          {id:2, label:'分销商'},
          {id:3, label:'一次性客户'},
          {id:4, label:'内部客户'},
        ]
      }else{
        this.customerSelTypeList = [
          {id:1, label:'门店'},
          {id:2, label:'分销商'}
        ]
      }

      //获取商品信息
      this.skuInfo = this.$route.query;
      console.log('this.skuInfo ',this.skuInfo )
      this.skuSellConfigId = this.skuInfo.id;
      this.currSkuCode = this.skuInfo.skuCode;
      this.currSkuName = this.skuInfo.goodsName;
      // this.allSellNum = this.skuInfo.allSellNum;
      this.editAllSellNum = this.skuInfo.allSellNum;
      // this.editFlag = (this.skuInfo.stats == 1 || this.skuInfo.stats == 'true') ? true : false;
      this.editFlag = this.skuInfo.stats ? true : false;
      this.sellType = parseInt(this.skuInfo.sellType);
      //判断是否已添加过数据
      if(this.sellType == 0 && this.editFlag){//未添加
        this.sellType = '';
        this.initFlag = false;
      }else{//已添加
        this.getTableData();
      }
      //菜单导航
      this.breadcrumb = [
        {
          title: '商品上架',
          url: '/modules/commodity/sys/on-shelves/index'
        },
        {
          title: this.modalTitle,
          active: true
        }
      ];

    },
    components:{
      commodityTable,GcCmpVsInput,SearchInput,
      VsTable,VsTd,VsTh,VsTr
    },
    watch:{
      customerSelType(value){
        console.log(value.length);
        if(this.$doMainFunc() === '力当家'){
          if(!value.length){
            //清空数据
            this.customerType = [];
          }else if(value == this.customerSelTypeList[0].label){//门店
            this.customerTypeOptions = Customer_Store_Types_Opts;
            //移除分销商下拉框
            this.customerType = this.customerType.filter(customer => {
              const activeIndex = Customer_Store_Types_Opts.findIndex(store => store.label == customer);
              return activeIndex != -1;
            })
          }else if(value == this.customerSelTypeList[1].label){
            this.customerTypeOptions = Customer_Types_Goods_Opts;
            //移除分销商下拉框
            this.customerType = this.customerType.filter(customer => {
              const activeIndex = Customer_Types_Goods_Opts.findIndex(store => store.label == customer);
              return activeIndex != -1;
            })
          }else if(value == this.customerSelTypeList[2].label && this.$doMainFunc() === '力当家'){ //力当家一次性客户
            this.customerTypeOptions = Customer_once_Types_Goods_Opts;
            //移除分销商下拉框
            this.customerType = this.customerType.filter(customer => {
              const activeIndex = Customer_once_Types_Goods_Opts.findIndex(store => store.label == customer);
              return activeIndex != -1;
            })

          }else if (value == this.customerSelTypeList[3].label && this.$doMainFunc() === '力当家'){ //力当家内部客户
            this.customerTypeOptions = Customer_inner_Types_Goods_Opts;
            //移除分销商下拉框
            this.customerType = this.customerType.filter(customer => {
              const activeIndex = Customer_inner_Types_Goods_Opts.findIndex(store => store.label == customer);
              return activeIndex != -1;
            })

          }
          else {

            if(value.length === 2){
              console.log(2)
              if(value.includes('一次性客户') && value.includes('分销商')){
                this.customerTypeOptions = [...Customer_Types_Goods_Opts,...Customer_once_Types_Goods_Opts]
              }else if(value.includes('一次性客户') && value.includes('内部客户')){
                this.customerTypeOptions = [...Customer_once_Types_Goods_Opts,...Customer_inner_Types_Goods_Opts]
              } else if(value.includes('一次性客户') && value.includes('门店')){
                this.customerTypeOptions = [...Customer_once_Types_Goods_Opts,...Customer_Store_Types_Opts]
              }else if(value.includes('内部客户') && value.includes('门店')){
                this.customerTypeOptions = [...Customer_inner_Types_Goods_Opts,...Customer_Store_Types_Opts]
              }else if(value.includes('内部客户') && value.includes('分销商')){
                this.customerTypeOptions = [...Customer_inner_Types_Goods_Opts,...Customer_Types_Goods_Opts]
              }
              else if(value.includes('门店') && value.includes('分销商')){
                this.customerTypeOptions = [...Customer_Store_Types_Opts,...Customer_Types_Goods_Opts]
              }
            }else if(value.length === 3){

              console.log(3)
              if(value.includes('分销商') && value.includes('门店') && value.includes('一次性客户')){
                this.customerTypeOptions  = [...Customer_Store_Types_Opts,...Customer_Types_Goods_Opts,...Customer_once_Types_Goods_Opts]
              }
              else if(value.includes('分销商') && value.includes('门店') && value.includes('内部客户')){
                this.customerTypeOptions  = [...Customer_Store_Types_Opts,...Customer_Types_Goods_Opts,...Customer_inner_Types_Goods_Opts]
              }
              else if(value.includes('门店') && value.includes('一次性客户') && value.includes('内部客户')){
                this.customerTypeOptions  = [...Customer_Store_Types_Opts,...Customer_once_Types_Goods_Opts,...Customer_inner_Types_Goods_Opts]
              }
              else if(value.includes('分销商') && value.includes('一次性客户') && value.includes('内部客户')){
                this.customerTypeOptions  = [...Customer_Types_Goods_Opts,...Customer_once_Types_Goods_Opts,...Customer_inner_Types_Goods_Opts]
              }
            }else{
              console.log(4444);
              this.customerTypeOptions  = [...Customer_Store_Types_Opts,...Customer_Types_Goods_Opts,...Customer_once_Types_Goods_Opts,...Customer_inner_Types_Goods_Opts]
            }

          }
        }else{
          if(!value.length){
            //清空数据
            this.customerType = [];
          }else if(value == this.customerSelTypeList[0].label){//门店
            this.customerTypeOptions = Customer_Store_Types_Opts;
            //移除分销商下拉框
            this.customerType = this.customerType.filter(customer => {
              const activeIndex = Customer_Store_Types_Opts.findIndex(store => store.label == customer);
              return activeIndex != -1;
            })
          }else if(value == this.customerSelTypeList[1].label){
            this.customerTypeOptions = Customer_Types_Goods_Opts;
            //移除分销商下拉框
            this.customerType = this.customerType.filter(customer => {
              const activeIndex = Customer_Types_Goods_Opts.findIndex(store => store.label == customer);
              return activeIndex != -1;
            })
          } else {
            // 两种状态都有
            this.isTypesAll = true;
            this.customerTypeOptions  =  Customer_Store_Types_Opts.concat(Customer_Types_Goods_Opts)
          }
        }

        // if(!this.initFlag){
        //   console.log('===999===', this.customerType);
        //   // console.log("非初始化,清空上架范围");
        //   // this.customerType = [];
        //   // this.tableData = [];
        //   // this.allTableData = [];
        // }
      },
      sellType(value, oldValue){
        this.shelfNum = 0;
        //非初始化时清空总上架数
        if(oldValue != ''){
          this.skuInfo.allSellNum = 0;
          this.editAllSellNum = 0;
          this.allSellNum = 0;
        }

        if(value == this.shelfModeTypes.MEARGE){
          this.mergeFlag = true;
        }else{
          this.mergeFlag = false;
        }
        if(this.allTableData.length){
          this.allTableData = this.allTableData.map(item => {
            item.oldNum = 0;
            item.shelfNum = 0;
            item.num = 0;
            return item;
          })
        }
      },
      //上架逻辑 ：0减量,1增量
      shelfLogic(){
        this.shelfNum = 0;
        this.computeAllSelNum();
      },
      //上架数量
      shelfNum(value){
        this.computeAllSelNum();
      },
      //上架类型
      customerType(value, oldValue){
        //初始化的时候不加载数据
        // this.shelfNum = 0;
        console.log('editAllSellNum',this.editAllSellNum)
        this.skuInfo.allSellNum = this.editAllSellNum;
        // if(!this.initFlag && (!this.compareArr(this.skuInfo.customerType, value) || !this.compareArr(oldValue, value))){
        //   this.getCustomerData(value);
        // }else{
        //   this.initFlag = false;
        // }
        // console.log(value)
        this.getCustomerData(value);
      }
    },
    methods: {
      //获取明细信息
      async getTableData(){
        this.tableData = [];
        this.allTableData = [];
        let resp = await OnShelvesApi.getSkuSellDetail({skuSellConfigId: this.skuSellConfigId});
        this.localPager.page = 1;
        var _this = this;
        if (resp.succ == 1 && resp.code != $busErrorCode) {
          let resData = resp.result;
          if (this.deleteTableData.length > 0) {
            resData = resData.filter(row => {
              const existsIndex = this.deleteTableData.findIndex(selected => selected.userId == row.userId);
              if(existsIndex == -1 ){
                return row;
              }
            })
          }
          //  _this.allTableData.push(resData);
          _this.customerType = [];
          _this.skuInfo.customerType = [];
          let storeTypeFlag = false;
          let userTypeFlag = false;
          resData.forEach((item, index) =>{
            item.skuName = _this.currSkuName;
            item.skuCode = _this.currSkuCode;
            item.customerType = item.userType;
            item.customerName = item.userName;
            item.shelfLogic = 1; //上架逻辑，1是增量，0是减量
            //渲染上架范围
            if(_this.customerType.length == 0){
              _this.customerType.push(item.userType);
              _this.skuInfo.customerType.push(item.userType);
            }else{
              let exists = _this.customerType.filter(cust => cust == item.userType);
              if(exists.length == 0){
                _this.customerType.push(item.userType);
                _this.skuInfo.customerType.push(item.userType);
              }

            }
            _this.customerType = this.customerType.filter(n => n);
            if(index == 0){
              _this.sellType = item.sellType;
            }
            //剩余上架数
            item.oldNum = item.num;
            //本次上架数
            item.shelfNum = 0;
            //初始化的时候删除标识为false
            item.deleteFlag = false;
            _this.allTableData.push(item);
            let typeId = item.userId +'';
            if (typeId.indexOf(this.userIdprefix) > -1) {
              storeTypeFlag = true;
            } else {
              userTypeFlag = true;
            }
          });
          //查询上架类型
          let customerType= [];
          // console.log('_this.customerType',_this.customerType)
          _this.customerSelTypeList.map(store =>{
            console.log(store);
            customerType.push(store.label)
          });

          // Customer_Store_Types_Opts.map(store =>{
          //   if(store.label == _this.customerType[0]){
          //     storeTypeFlag=true;
          //   } else {
          //     userTypeFlag=true;
          //   }
          // });
          // console.log('resData',resData)
          // resData.map(type =>{
          //   let typeId =type.userId +'';
          //   if (typeId.indexOf(this.userIdprefix) > -1) {
          //     storeTypeFlag=true;
          //   } else {
          //     userTypeFlag=true;
          //   }
          // });


          //渲染第一页
          this.loadData();
          //获取分页总页数
          //this.localPager.total =  Math.ceil(resData.length / this.localPager.size);
          this.localPager.total = resData.length;
          let fxs=false
          let mdkeh=false
          let ldjOnce = false;//力当家一次性客户
          let ldjInner = false;//力当家内部客户
          // console.log(storeTypeFlag,userTypeFlag)
          resData.map(item =>{
            if(item.userType=='大连锁商SKA'||item.userType=='大零售商SCA'||item.userType=='省代PD'||item.userType=='CVS'){
              fxs = true;
            }else if(item.userType === '一次性客户' && this.$doMainFunc() === '力当家'){
              ldjOnce = true;
            }else if(item.userType=='品类店'||item.userType=='明星店'||item.userType=='集合店'||item.userType=='专柜店'||item.userType=='专卖店'){
              mdkeh = true;
            }else if(item.userType === '内部客户' && this.$doMainFunc() === '力当家'){
              ldjInner = true
            }
          })
          //回显上架类型
          // if (storeTypeFlag && userTypeFlag) {
          //   // console.log('customerType',customerType)
          //    _this.customerSelType = customerType
          // } else if(storeTypeFlag) {
          //   _this.customerSelType =  _this.customerSelTypeList[0].label
          // } else {
          //   _this.customerSelType =  _this.customerSelTypeList[1].label
          // }
          if (fxs && mdkeh  && !ldjOnce && !ldjInner) {
            // console.log('customerType',customerType)
            _this.customerSelType = customerType
          }else if(ldjInner && ldjOnce && !fxs && !mdkeh){
            _this.customerSelType = ['一次性客户','内部客户'];
          }else if(fxs && ldjOnce && ldjInner && !mdkeh){
            _this.customerSelType = ['分销商','一次性客户','内部客户'];
          }
          else if(fxs && ldjOnce && !ldjInner && !mdkeh){
            _this.customerSelType = ['分销商','一次性客户'];
          }else if(fxs && ldjInner && !ldjOnce && !mdkeh){
            _this.customerSelType = ['分销商','内部客户'];
          }else if(mdkeh && ldjInner && !fxs && !ldjOnce){
            _this.customerSelType = ['门店','内部客户'];
          }else if(mdkeh && ldjOnce && !fxs && !ldjInner){
            _this.customerSelType = ['门店','一次性客户'];
          }else if(mdkeh && !ldjOnce && !ldjInner && !fxs){
            _this.customerSelType = ['门店'];
          }
          else if(fxs && !ldjInner && !ldjOnce && !mdkeh) {
            _this.customerSelType =  _this.customerSelTypeList[1].label

          }else if(ldjInner && !fxs && !mdkeh && !ldjOnce){
            _this.customerSelType =  _this.customerSelTypeList[3].label
          }else if (ldjOnce && !fxs && !mdkeh && !ldjInner){
            _this.customerSelType =  _this.customerSelTypeList[2].label
          }
          else {
            _this.customerSelType =  ['分销商','门店','内部客户','一次性客户']
          }
          //  _this.customerSelType = storeTypeFlag ? _this.customerSelTypeList[0].label : _this.customerSelTypeList[1].label;

          //  setTimeout(() => {
          //   this.getCustomerData(_this.customerType);
          // }, 0);

        }else{
          this.$notifyError(resp.error || '加载客户列表失败');
        }
      },
      //本地翻页
      loadData() {
        // if(this.searchDataCode != 1) {
        this.tableData = [];
        let min = (this.localPager.page - 1) * this.localPager.size;
        let max = min + this.localPager.size;
        console.log(min,max);
        //除去已经删除的
        console.log(this.allTableData);
        let activeTableData = this.allTableData.filter(item => !item.deleteFlag);
        //判断是否有筛选条件
        if (this.filterText != '') {
          activeTableData = activeTableData.filter(
                  item => item.customerName.indexOf(this.filterText) > -1
          );
        }
        console.log(activeTableData);
        //重新计算total
        console.log(activeTableData.length);
        this.localPager.total = activeTableData.length;
        console.log(min,max);
        activeTableData.forEach(async (item, index) => {
          if(index >= min && index < max) {
            //查询客户类型
            // let customer = await this.getCustomerInfo(item.userId);
            // item.customerType = customer == '' ? '' : customer.type;
            // item.customerName = customer == '' ? '' : customer.name;
            //剩余上架数
            // item.oldNum = item.num;
            //本次上架数
            // item.shelfNum = 0;
            //该客户总上架数：根据上架逻辑做加减
            // item.num = item.num || 0;
            this.tableData.push(item);
          }
        });
        // }
      },
      //查询客户
      searchData(){
        //清空已选择的数据
        this.clearSelectedData();
        this.loadData();
      },
      //获取客户类型
      async getCustomerData(type){
        let store_type = [];
        let user_type = [];
        let once_type = [];
        let inner_type = [];
        Customer_Store_Types_Opts.forEach((types) => {
          type.forEach(item => {
            if (types.label == item) {
              store_type.push(item)
            }
          })
        });
        Customer_Types_Goods_Opts.forEach((types) => {
          type.forEach(item => {
            if (types.label == item) {
              user_type.push(item)
            }
          })
        });
        Customer_once_Types_Goods_Opts.forEach((types) => {
          type.forEach(item => {
            if (types.label == item) {
              once_type.push(item)
            }
          })
        });
        Customer_inner_Types_Goods_Opts.forEach((types) => {
          type.forEach(item => {
            if (types.label == item) {
              inner_type.push(item)
            }
          })
        });

        // console.log('过滤门店',store_type)
        // console.log('过滤分销商',user_type)

        let pager = {
          page: 1,
          num: 9999999, //后续需要改成不分页的
          total: 0
        };
        this.tableData = [];
        this.deleteTableData = [];
        // this.allSellNum = this.editAllSellNum;
        let oldAllTableData = JSON.parse(JSON.stringify(this.allTableData));
        oldAllTableData = oldAllTableData.filter(item => !item.deleteFlag)
        this.allTableData = [];
        if(type.length > 0){
          //将移除的客户类型从删除的列表里移除TODO
          // this.deleteTableData = this.deleteTableData.filter(item => {
          //   const exsIndex = type.findIndex(t => t == item.customerType);
          //   return exsIndex != -1;
          // });
          //遗留的数据
          let oldTypes = [];
          oldAllTableData = oldAllTableData.filter(item => {
            const currCusType = item.customerType;
            const exsIndex = type.findIndex(t => t == currCusType);
            if(oldTypes.indexOf(currCusType) == -1){
              oldTypes.push(currCusType)
            }
            return exsIndex != -1;
          });

          //筛选门店
          let resp;
          this.$vs.loading()
          if(this.customerSelTypeList[0].label == this.customerSelType && !this.isTypesAll){
            // 门店
            resp = await OnShelvesApi.getStoreList(pager.page, pager.num, type);
            //格式化id 门店类型的需要添加store前缀
            if(resp.length > 0){
              resp.forEach(item => {
                item.id = this.userIdprefix + item.id
              })
            }

          }else if(this.customerSelTypeList[1].label == this.customerSelType && !this.isTypesAll){
            //分销商
            resp = await OnShelvesApi.getClientList(pager.page, pager.num, type);

          } else {
            // 门店和分销商都有
            user_type = [...user_type,...once_type,...inner_type];
            resp = await OnShelvesApi.getUserAndStoreList(pager.page, pager.num, user_type, store_type,);
            let storeArr = ['品类店','明星店','集合店','专柜店','专卖店'];
            for (let i = 0; i < resp.length; i++) {
              if(storeArr.includes(resp[i].type)){
                resp[i].id = 'store'+resp[i].id;
              }
            }
          }

          if (resp) {
            this.isTypesAll = false;
            let resData = []
            if (resp.store_list || resp.user_list) {
              if (resp.store_list) {
                resp.store_list.forEach(item => {
                  item.id = this.userIdprefix + item.id
                })

              }
              resData =  resp.store_list.concat(resp.user_list)
            } else {
              resData = resp;
            }
            console.log(resData,oldAllTableData)
            if(resData.length > 0){
              //移除已经删除的数据
              // console.log('===已删除====', this.deleteTableData);
              // if (this.deleteTableData.length > 0) {
              //   resData = resData.filter(row => {
              //     const existsIndex = this.deleteTableData.findIndex(selected => selected.userId == row.id);
              //     return existsIndex == -1;
              //   })
              // }
              //组装数据
              resData.map((item,index) =>{
                let obj = {};
                //删除的时候id不是此处id obj.id = item.id;
                obj.userId = item.id;
                obj.skuName = this.currSkuName;
                obj.skuCode = this.currSkuCode;
                obj.sellType = this.sellType;
                obj.customerType = item.type;
                obj.customerName = item.name;


                const oldIndex = oldAllTableData.findIndex(allData => allData.userId == item.id)
                // console.log(oldIndex)
                if(oldIndex == -1){
                  //剩余上架数
                  obj.oldNum = 0;
                  //本次上架数
                  obj.shelfNum = 0;
                  obj.shelfLogic = 1; //上架逻辑，1是增量，0是减量

                }else{
                  obj.oldNum = oldAllTableData[oldIndex].oldNum;
                  //本次上架数
                  obj.shelfNum = oldAllTableData[oldIndex].shelfNum;
                  obj.shelfLogic = oldAllTableData[oldIndex].shelfLogic; //上架逻辑，1是增量，0是减量
                }
                //该客户总上架数：根据上架逻辑做加减
                obj.num = Number(obj.oldNum) + Number(obj.shelfNum);


                //改为分页 this.tableData.push(obj);
                //新的客户类型或者是已经存在的客户展示出来
                if(oldTypes.indexOf(item.type) == -1 || oldIndex != -1){
                  //删除标识
                  obj.deleteFlag = false;
                  this.allTableData.push(obj);
                }else {
                  //删除标识
                  obj.deleteFlag = true;
                  this.deleteTableData.push(obj);
                }
              });
              //更新分页参数 todo
              // let allTotal = resp.pager.total + this.localPager.total;
              // this.localPager.total = Math.ceil(allTotal / this.localPager.size);
              this.localPager.total = resData.length;
              // this.searchDataCode = 0;
              this.localPager.page = 1;
              this.loadData();
            }
          }
          this.$vs.loading.close();
        }else{
          //清空已删除的数据
          this.deleteTableData = [];
        }
      },
      //获取客户/门店信息
      async getCustomerInfo(uid) {
        if(!uid || uid == ''){
          console.log('查询信息失败,客户id为空:'+uid);
          return '';
        }else{
          let resp
          if(uid.indexOf(this.userIdprefix) > -1){//门店
            let id = uid.split(this.userIdprefix)[1];
            resp = await Mod_Stores.getStoreInfo(id);
          }else{ //经销商
            resp = await Mod_Clients.getClientInfo(uid);
          }
          return resp;
        }
      },
      //删除客户TODO
      deleteCustomer(row){
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `操作提示`,
          text: '是否确认删除',
          acceptText: '确认',
          cancelText: '取消',
          accept: () => {
            this.doDelete(row);
          }
        })
      },
      async doDelete(row){
        // 调接口删除 todo-ljm
        console.log('row',row)
        //有id做实时删除
        if(row.id){
          let param = {
            id: row.id
          }
          let resp = await OnShelvesApi.deleteByDetailId(param);
          if (resp.succ == 1 && resp.code != $busErrorCode) {
            this.$notifySuccess('操作成功')
            // this.allSellNum = Number(this.allSellNum) - Number(row.num)
            //this.getTableData();

          }else{
            this.$notifyError(resp.error || '操作失败');
          }
        }
        //本地删除
        this.tableData = this.tableData.filter(item => item.userId != row.userId);
        this.allTableData = this.allTableData.map(item =>{
          if(item.userId == row.userId){
            item.shelfNum = 0;
            item.deleteFlag = true;
          }
          return item;
        });
        this.deleteTableData.push(row);
        this.loadData();
      },
      //模糊搜索添加选择事件
      addSelectCustomer(item){
        item.oldNum = 0
        item.deleteFlag = false;
        this.delSelected = item;
        this.addCustomer(item);
      },
      //添加客户
      addCustomer(){
        if(Object.keys(this.delSelected).length == 0){
          this.$notifyError("请选择要添加的客户");
        }else{
          let currUserId = this.delSelected.userId;
          //判断是否是已有的数据
          const oldIndex = this.allTableData.findIndex(item => item.userId == currUserId);
          if(oldIndex != -1){//删除已有的数据
            this.allTableData.splice(oldIndex, 1);
          }
          this.allTableData.unshift(this.delSelected);
          // this.allTableData = this.allTableData.map(item =>{
          //   if(item.userId == currUserId){
          //     item.deleteFlag = false;
          //   }
          //   return item;
          // });
          this.deleteTableData = this.deleteTableData.filter(del => del.userId != currUserId);
          this.delSelected = [];
          this.loadData();
        }
      },
      // 分开合并上架旧版
      // shelfNumChange(index,val){
      //   // this.tableData[index].shelfNum = parseInt(val);
      //   this.$set(this.tableData[index], 'shelfNum', parseInt(val)) ;
      //   this.doChangeShelfNum(this.tableData[index])
      // },
      // 分开上架
      shelfNumChange(tr,index,val){
        if(this.sellType == 1) {
          console.log('合并上架')
          // this.tableData[index].shelfNum = parseInt(val);
          this.$set(this.tableData[index], 'shelfNum', parseInt(val)) ;
          this.doChangeShelfNum(this.tableData[index])
        } else if(this.sellType == 2) {
          console.log('分开上架')
          let list = this.tableData;
          // this.allSellNum = 0;

          this.tableData = list.map(item => {
            let addNum = 0;
            // console.log('item',item)

            if(item.shelfLogic == 1){
              console.log('增量',item)
              // 增量
              addNum += (Number(item.oldNum) + Number(item.shelfNum))
            } else if(item.shelfLogic == 0){
              // 减量
              console.log('减量～～～',item)
              addNum += (Number(item.oldNum) - Number(item.shelfNum))
              if (item.shelfNum > item.oldNum) {
                item.shelfNum = item.oldNum
                this.$notifyError('剩余上架数为0，不支持减量');
              }
            }
            item.num = addNum;
            // this.allSellNum +=  addNum;
            return item;
          })
          // console.log('this.allSellNum ',this.allSellNum )
        }

      },
      //确认上架
      submit(){
        let currUsingData = this.allTableData.filter(item => !item.deleteFlag);
        if(currUsingData.length == 0){
          this.$notifyError('请先选择要上架的客户');
        }else{
          this.$vs.dialog({
            type: 'confirm',
            color: 'primary',
            title: `操作提示`,
            text: '您确认上架吗？',
            acceptText: '确认',
            cancelText: '取消',
            accept: () => {
              this.doSubmit();
            }
          })
        }
      },
      async doSubmit(){
        this.$vs.loading()
        let param ={};
        param.id = this.skuSellConfigId;
        param.skuCode = this.currSkuCode;
        param.sellType = this.sellType;//上架模式

        if(this.mergeFlag){//合并上架的商品配额总上架数
          param.num = this.allSellNum;
        }
        let skuSellConfigDetailVOList = [];
        console.log(this.allTableData);
        // return;
        this.allTableData.map(item => {
          if(!item.deleteFlag){//不是删除的
            let obj = {};
            obj.skuSellConfigId = this.skuSellConfigId;
            obj.skuCode = this.currSkuCode;
            // console.log('this.customerSelType',this.customerSelType)
            // if(this.customerSelTypeList[0].label == this.customerSelType){
            //   item.userId = this.userIdprefix + item.userId;
            // }
            // this.customerSelType.forEach(ele => {
            //   let currUserId = item.userId  + ''
            //   if (ele == this.customerSelTypeList[0].label && currUserId.indexOf(this.userIdprefix) == -1) {
            //     item.userId = this.userIdprefix + item.userId;
            //   }
            // })
            obj.userId = item.userId,
                    obj.num = item.num,
                    obj.sellType = this.sellType;
            skuSellConfigDetailVOList.push(obj);
          }
        })
        param.skuSellConfigDetailVOList = skuSellConfigDetailVOList;
        let resp = await OnShelvesApi.updateSkuSell(param);
        if (resp.succ == 1 && resp.code != $busErrorCode) {
          // this.cancel();
          this.$notifySuccess('操作成功')
          this.$vs.loading.close()
        }else{
          this.$vs.loading.close()
          this.$notifyError(resp.error || '更新失败');
        }
      },
      // 确认取消
      cancelAffirm(){
        this.$vs.dialog({
          type: "confirm",
          title: `请确认`,
          text: `是否确认取消`,
          acceptText: "确认",
          cancelText: "取消",
          accept: () => {
            this.cancel();
          },
        });
      },
      cancel(){
        this.$router.push({
          path: `/modules/commodity/sys/on-shelves/index`
        }).catch(() => {})
      },
      // 分开上架--增量
      shelfLogicAdd(tr){
        tr.shelfLogic = 1;
        tr.shelfNum = 0;
        tr.num =  Number(tr.oldNum);
        // this.$set(this.tableData[index], 'shelfNum', 0);
        const allIndex = this.allTableData.findIndex(item => item.userId == tr.userId);
        console.log('=增量==allIndex===',allIndex);
        this.$set(this.allTableData[allIndex], 'shelfNum', 0)
        this.$set(this.allTableData[allIndex], 'num', tr.num)
        // this.shelfLogic = 1;
      },
      // 分开上架--减量
      shelfLogicReduce(tr){
        console.log('tr减量～～',tr)
        tr.shelfLogic = 0;
        tr.shelfNum = 0;
        tr.num =  Number(tr.oldNum);
        const allIndex = this.allTableData.findIndex(item => item.userId == tr.userId);
        this.$set(this.allTableData[allIndex], 'shelfNum', 0);
        this.$set(this.allTableData[allIndex], 'num', tr.num)
        // this.shelfLogic = 0;
      },
      //计算总上架数
      computeAllSelNum(){
        // this.skuInfo.allSellNum = this.allSellNum || this.skuInfo.allSellNum
        // console.log('上架计算allSellNum',this.allSellNum)
        // console.log('editAllSellNum',this.editAllSellNum)
        // console.log('this.skuInfo.allSellNum',this.skuInfo.allSellNum)
        if(this.shelfLogic === this.logic_type.ADD){//增量
          this.allSellNum = parseInt(this.editAllSellNum) + ( parseInt(this.skuInfo.allSellNum) + parseInt(this.shelfNum) );
          this.allSellNum = parseInt(this.allSellNum);
        }else if(this.shelfLogic === this.logic_type.REDUCE){//减量
          this.allSellNum = parseInt(this.editAllSellNum) + ( parseInt(this.skuInfo.allSellNum) - parseInt(this.shelfNum) );
          this.allSellNum = parseInt(this.allSellNum);

        }else{
          this.$notifyError('请选择上架逻辑');
        }
        console.log('上架计算allSellNum222',this.allSellNum)
      },
      //如果是分开上架需要对上架数根据上架逻辑做加减
      doChangeShelfNum(tr) {
        if(!this.mergeFlag){
          if(this.shelfLogic === this.logic_type.ADD){//增量
            this.computeTrAllSelNum(tr.id, true);

          }else if(this.shelfLogic === this.logic_type.REDUCE){//减量
            this.computeTrAllSelNum(tr.id, false);
          }else{
            tr.shelfNum = 0;
            this.$notifyError('请选择上架逻辑');
          }
        }
      },
      computeTrAllSelNum(id, addFlag){
        this.allSellNum = 0;
        this.tableData = this.tableData.map(item => {
          if(item.id == id){
            item.num = addFlag ? (item.oldNum + item.shelfNum) : (item.oldNum - item.shelfNum);
          }

          return item;
        });
        this.allTableData.map(item => {
          if(item.id == id && !item.deleteFlag){
            item.num = addFlag ? (item.oldNum + item.shelfNum) : (item.oldNum - item.shelfNum);
          }
          this.allSellNum += item.num;
          return item;
        });
      },
      //判断数组是否相同
      compareArr(arr1, arr2){
        let sameFlag = true;
        if (!arr1 || !arr2) {
          sameFlag = false;
        } else if (arr1.length != arr2.length) {
          sameFlag = false;
        }
        if(sameFlag){
          arr1.map(item =>{
            if (arr2.indexOf(item) == -1) {
              sameFlag = false;
            }
          });
          arr2.map(item =>{
            if (arr1.indexOf(item) == -1) {
              sameFlag = false;
            }
          });
        }
        return sameFlag;
      },
      //批量删除,批量清0的时候重新整合表格数据
      formatTableData(isDelete){
        if(this.selectedRowData.length == 0){
          this.$notifyError('请先选择要操作的数据');
        }else{
          this.allTableData = this.allTableData.map(row =>{
            const existsIndex = this.selectedRowData.findIndex(selected => selected.userId == row.userId);
            if(existsIndex != -1){
              row.shelfNum = 0;
              row.num = row.oldNum
              if(isDelete){
                row.deleteFlag = true;
                this.deleteTableData.push(row);
              }
            }
            return row;
          });
          // this.getTableData()
          if(isDelete){
            this.loadData();
          }else{
            this.tableData = this.tableData.filter(row =>{
              const existsIndex = this.selectedRowData.findIndex(selected => selected.userId == row.userId);
              if(existsIndex == -1 ){
                return row;
              }else if(!isDelete){
                row.shelfNum = 0;
                return row;
              }
            });
          }
          this.selectedRowData = [];
          this.$notifySuccess('操作成功');
        }
      },
      //批量清空上架数
      clearTableData(){
        let that = this;
        if(that.selectedRowData.length == 0){
          that.$notifyError('请先选择要操作的数据');
        }else{
          that.$vs.dialog({
            type: "confirm",
            title: `请确认`,
            text: `是否批量清空剩余上架数？`,
            acceptText: "确认",
            cancelText: "取消",
            accept: () => {
              this.tableData = this.tableData.filter(row =>{
                const existsIndex = this.selectedRowData.findIndex(selected => selected.userId == row.userId);
                if(existsIndex == -1 ){
                  return row;
                }else{
                  row.oldNum = 0;
                  row.num = 0;
                  return row;
                }
              });
            },
          });
        }

      },
      //清楚已选择的数据
      clearSelectedData(){
        //清空已选择的选项
        if(this.$refs['table'].isCheckedMultiple){
          this.$refs['table'].changeCheckedMultiple();
        }
      },
      //模糊搜索获取sku信息
      async searchInputSuggest(value){
        if(this.deleteTableData.length > 0){
          this.delCustomerOptions = this.deleteTableData.filter(item => item.customerName.indexOf(value) > -1);
        }else{
          this.delCustomerOptions = [];
        }
      },
      //更改每页条数
      handleSizeChange(val){
        this.selectedRowData = [];
        this.localPager.size = val;
        this.loadData();
      },
      handleCurrentChange(val){
        this.selectedRowData = [];
        this.localPager.page = val;
        this.loadData();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/modules/commodity-sys/commodity.scss';
  .main-wrap{
    background-color: #fff;
    padding: 0 24px;
  }
  .center-num {
    /deep/ .vs-table-text {
      justify-content: center;
    }
  }
  #edit-good-form{
    padding: 4px 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    .form-item{
      @include flex-mixin(row, center, flex-start);
      margin-top: 20px;
      .label{
        font-size: 14px;
        font-weight: 400;
        color: #5E5873;
        margin-right: 16px;
      }
      /deep/ .v-select, /deep/ .vs-con-input{
        width: 333px;
      }
      .small-select{
        width: 150px;
        margin-right: 16px;
      }
    }
  }
  .firstTitle{
    margin-top: 40px;
  }
  #customerTable{
    margin-top: 24px;
  }
  .bot-btn-wrap{
    @include flex-mixin(row, center, center);
    padding: 24px 0;
  }
  .common-btn {
    height: 38px;
    font-size: 14px;
  }
  .input-tip{
    color: var(--vs-primary);
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5E5873;
    width: 80px;
  }
  .search-add-wrap {
    position: relative;
    margin-left: 16px;
    width: 300px;
    .table-inner-btn {
      position: absolute;
      right: 0;
      font-size: 14px;
      z-index: 1000;
    }
  }
  .shelfLogic {
    width: 80px;
    border-radius: 15px;
    height: 27px;
    line-height: 27px;
    display: inline-block;
    border:1px solid #4090ff;
    overflow: hidden;
    vertical-align: middle;
    margin-right: 5px;
    .item {
      width: 50%;
      display: inline-block;
      vertical-align: top;
      text-align: center;
      color: #4090ff;
      font-size: 12px;
    }
    .active {
      background: #4090ff;
      color: #fff;
    }
  }
  .text-danger {
    vertical-align: middle;
  }
  .form__clear {
    /deep/ .v-select .vs__dropdown-toggle .vs__actions .vs__clear {
      display: none !important;
    }
  }


</style>
